module.exports = __webpack_public_path__ + "img/yjjb.c7e3b855.png";